export enum CreateSteps {
  Initialize = 'initialize',
  Start = 'start',
  Password = 'passwordForm',
  CredentialsSubmitted = 'userStep',
  InformationsSubmitted = 'teamNameFormLayout',
  TeamUrlSubmitted = 'teamUrlForm',
  JoinableTeams = 'JoinableTeams',
  Creating = 'creating',
  Finished = 'finished',
  EmailVerification = 'emailVerificationForm',
}
